export default __webpack_public_path__ + "static/media/Fengdu.307a3166.jpg";